export default __webpack_public_path__ + "static/media/udaipur2.e3de009a.jpg";